import React from 'react';
const MenuExpandSVG = ({ color = 'black', className, ...props }) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='18'
      height='14'
      viewBox='0 0 18 14'
      fill='none'
      {...props}
      className={className}
    >
      <path
        d='M9 12.4286H1M17 6.71429H1M17 1H1'
        stroke='#0744E1'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
};

export default MenuExpandSVG;
